// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fuWj","largestCol":"styles_largestCol__3vT47","smallestCol":"styles_smallestCol__2jQHN"};